import Kriseinformasjon, { type KriseinformasjonProps } from './Kriseinformasjon';

interface KrisePanelProps {
  kriseinformasjon: KriseinformasjonProps;
}

const KrisePanel: React.FunctionComponent<KrisePanelProps> = ({ kriseinformasjon }) => <Kriseinformasjon {...kriseinformasjon} />;

export default KrisePanel;
